import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useTheYardAnalytics } from "./theyard_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./theyard_partner_config";

const Theme = lazyWithRetry(() => import("./theyard_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer:
      "The hours for the day pass is from 9:30 AM to 5:30 PM, Monday through Friday.",
  },

  {
    question: "Can I share my pass with other people?",
    answer:
      "The Yard Day Pass is for personal use only and is not transferable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer:
      "Yes, the meeting rooms are charged at an hourly rate. " +
      "Please get in touch with the community manager for availability and pricing options.",
  },

  {
    question: "Can I use the printer?",
    answer:
      "Yes, please get in touch with the community manager and we will assist you.",
  },

  {
    question: "Can I meet with clients or bring a guest using my day pass?",
    answer:
      "Your day pass is for personal use only and doesn’t cover guests. You may purchase additional day passes for each of your guests.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "The kitchen, refrigerator and microwave is available for your use.",
  },

  {
    question: "Do you offer coffee or tea?",
    answer:
      "Modern kitchens include complimentary coffee by Eleva and tea by Harney & Sons.",
  },

  {
    question: "Can I cancel my day pass purchase?",
    answer:
      "Yes, the Yard Day Pass can be cancelled and fully refunded 24 hours before the day of booking.",
  },
  {
    question: "Can I change the date of my day pass booking?",
    answer:
      "Yes. Please either call us or reply to the confirmation email and we will take care of it.",
  },
];

export function OfferingTheYardDayPass() {
  useTheYardAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Spread out in our accommodating, well ventilated, and socially distanced lounge. We've created unique work areas catered for all types of thinkers. ​Enjoy all the member amenities for the day.`,
          faqs,
          testimonials: testimonials,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
